import { mapToCanActivate, Routes } from "@angular/router";

import { RoutingPath } from "@core/enums/routing-path";
import { AuthGuard } from "@core/guards/route-guard";
import { SetPasswordFlow } from "@features/auth/set-password/set-password-flow";

export const routes: Routes = [
  {
    path: RoutingPath.Login,
    loadChildren: (): any =>
      import("@views/login/login-routes").then((m) => m.routes),
  },
  {
    path: RoutingPath.ForgotPassword,
    loadComponent: (): any =>
      import("@features/auth/forgot-password/forgot-password.component").then(
        (m) => m.ForgotPasswordComponent
      ),
  },
  // Public landings for the emailed activation / reset links. Outside the
  // AuthGuard: the user has no session, and a guarded bounce drops the query.
  ...[
    {
      flow: SetPasswordFlow.ConfirmEmail,
      paths: ["account/confirmEmail", "account/confirm-email"],
    },
    {
      flow: SetPasswordFlow.ResetPassword,
      paths: ["account/ConfirmNewPassword", "account/confirm-new-password"],
    },
  ].flatMap(({ flow, paths }) =>
    paths.map((path) => ({
      path,
      data: { flow },
      loadComponent: (): any =>
        import("@features/auth/set-password/set-password.component").then(
          (m) => m.SetPasswordComponent
        ),
    }))
  ),
  {
    // Public landing for the back-office "log in as this customer" hand-off. Must stay outside the
    // AuthGuard: the user has no portal session yet when they arrive here.
    path: RoutingPath.Impersonate,
    loadChildren: (): any =>
      import("@views/impersonate/impersonate-routes").then((m) => m.routes),
  },
  {
    // Legacy hand-off path kept from the old ASP.NET portal. The back-office may still redirect
    // here (`/ImpersonationAccount/Login?...`); route it to the same landing handler so it no
    // longer 404s while the back-office/API move to the token-based `/impersonate` contract.
    path: "ImpersonationAccount/Login",
    loadChildren: (): any =>
      import("@views/impersonate/impersonate-routes").then((m) => m.routes),
  },
  {
    path: "",
    loadChildren: (): any =>
      import("./views/wrapper-routes").then((m) => m.routes),
    canActivate: mapToCanActivate([AuthGuard]),
  },
  {
    path: "**",
    redirectTo: RoutingPath.NotFound,
  },
];
